import {SkipLinks} from 'io-sanita-theme/components';

export default SkipLinks;
